import { render, staticRenderFns } from "./ScheduledMessagesList.vue?vue&type=template&id=a8149c52&scoped=true&"
import script from "./ScheduledMessagesList.vue?vue&type=script&lang=js&"
export * from "./ScheduledMessagesList.vue?vue&type=script&lang=js&"
import style0 from "./ScheduledMessagesList.vue?vue&type=style&index=0&id=a8149c52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8149c52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8149c52')) {
      api.createRecord('a8149c52', component.options)
    } else {
      api.reload('a8149c52', component.options)
    }
    module.hot.accept("./ScheduledMessagesList.vue?vue&type=template&id=a8149c52&scoped=true&", function () {
      api.rerender('a8149c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ScheduledMessagesList.vue"
export default component.exports